import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

interface IncentiveTripPathItem {
  path?: number | null;
}

interface IncentiveTripPathProps {
  item: IncentiveTripPathItem;
}

export const IncentiveTripPath: React.FC<IncentiveTripPathProps> = ({
  item = {},
}: IncentiveTripPathProps) => {
  const {tt} = useTranslation('report.record.incentiveTripPath');
  const path = get(item, 'path', null);

  return (
    <>
      {tt(
        'incentivePath',
        generateComponentCallback({
          component: (
            <Text
              variant="body"
              emphasis="medium"
              {...testProperties(Reports.reportItPath)}>
              Path {path}
            </Text>
          ),
        }),
      )}
    </>
  );
};
